<template>
  <div class="popup-main">
    <el-dialog
      title="客户更新记录"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div class="m-b-10 f-s-12">
          <span>客户企业名称:{{ detail.customer_name }}</span>
          <span class="m-l-20">业务员:{{ detail.sales_man }}</span>
        </div>
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :max-height="tableConfig.maxHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :row-config="tableConfig.rowConfig"
          :columns="tableColumn"
          :data="selfList"
          :show-footer="!!selfList.length"
        >
          <!-- slot_default -->
          <template #default_create_date="{ row }">
            {{ row.create_date.slice(0, 10) }}
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '更新日期',
          field: 'create_date',
          slots: { default: 'default_create_date' },
          width: 160
        },
        {
          title: '更新备注',
          field: 'bei_zhu'
        },
        {
          title: '操作人员',
          field: 'do_man',
          width: 120
        }
      ]
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        maxHeight: 600
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initDetailData()
  },
  methods: {
    // 获取-详情数据
    initDetailData() {
      this.$api({
        method: 'post',
        url: '/admin/customers/changeInfo',
        data: {
          id: this.detail.id,
          currentPage: 1,
          pageSize: 500,
          sortData: {
            create_date: 'asc'
          }
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let result = this.$util.deepCopy(res.data.page.list)
            this.selfList = result
          }
        })
        .catch(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
